import { Lecturer } from '@type/buzzkuri/programs-categor'
import React from 'react'
import { CategoryLecturersContentItem } from './Item'
import { TransitionBtn } from '@components/shared/TransitionBtn'

type Props = {
  lecturers: Lecturer[]
}

export const CategoryLecturersContent = ({ lecturers }: Props): JSX.Element => (
  <div className="flex flex-col py-[10.7vw] px-[7.2vw] lg:px-0 lg:pt-[3.5vw] lg:pb-[3.9vw] bg-[#F7F6F5]">
    <div className="flex flex-col lg:flex-row justify-center">
      {lecturers.map((lecturer, i) => (
        <div key={i} className="lg:mx-[0.9vw] mb-[8vw] last:mb-0 lg:mb-0">
          <CategoryLecturersContentItem {...{ lecturer }} />
        </div>
      ))}
    </div>
    <TransitionBtn text="講師一覧を見る" url="/lecturers/" />
  </div>
)
